<template>
  <b-overlay :show="busy" rounded="sm">
    <b-card class="border-none py-0 mb-0 no-margin px-1">
      <!-- <b-card-header class="py-1 mb-2">
        <i :class="options.icon" class="text-primary mr-1"></i>
        {{ item.name }}
        <span class="text-warning"
          >&lt;{{ selection.length == 0 ? "new" : "edit" }}&gt;</span
        >
      </b-card-header> -->

      <b-card-body class="py-0">
        <b-tabs class="gridtabs">
          <b-tab active>
            <template #title>
              <i :class="options.icon" class="text-primary mr-1"></i>
              {{ item.name }}
              <span class="text-warning"
                >&lt;{{ selection.length == 0 ? "new" : "edit" }}&gt;</span
              >
            </template>
            <p class="py-3 px-0">
              <b-row>
                <b-col cols="12" sm="6" md="4" xl="3">
                  <b-form-group label="Name" label-for="name" label-cols="12">
                    <b-input-group>
                      <b-form-input
                        type="text"
                        v-model="item.name"
                        placeholder="Enter name"
                        size="sm"
                        :disabled="true"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button
                          size="sm"
                          variant="outline-secondary"
                          @click="item.name = ''"
                          :disabled="true"
                        >
                          <i class="fa fa-remove"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col cols="12" sm="6" md="4" xl="3">
                  <b-form-group label="API" label-for="api" label-cols="12">
                    <b-input-group>
                      <b-form-input
                        type="text"
                        v-model="item.api"
                        placeholder="Enter api"
                        size="sm"
                        :disabled="true"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button
                          size="sm"
                          variant="outline-secondary"
                          @click="item.api = ''"
                          :disabled="true"
                        >
                          <i class="fa fa-remove"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col cols="12" sm="6" md="4" xl="3">
                  <b-form-group
                    label="Enabled"
                    label-for="enabled"
                    label-cols="12"
                  >
                    <b-form-radio-group
                      id="enabled"
                      v-model="item.enabled"
                      :options="[
                        { text: 'Enabled', value: true },
                        { text: 'Disabled', value: false },
                      ]"
                      buttons
                      button-variant="outline-success"
                      size="sm"
                      name="radio-btn-outline"
                    ></b-form-radio-group>
                  </b-form-group>
                </b-col>
                <b-col cols="12" sm="6" md="4" xl="3">
                  <b-form-group
                    label="Date Last"
                    label-for="datelast"
                    label-cols="12"
                  >
                    <b-input-group>
                      <b-input-group-prepend>
                        <b-form-datepicker
                          size="sm"
                          v-model="item.datelast_df"
                          button-only
                          label-help=""
                          locale="en-GB"
                          hide-header
                          :disabled="true"
                        ></b-form-datepicker>
                      </b-input-group-prepend>
                      <b-form-input
                        size="sm"
                        id="date"
                        v-model="item.datelast_df"
                        type="text"
                        placeholder="YYYY-MM-DD"
                        autocomplete="off"
                        :disabled="true"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button
                          size="sm"
                          variant="outline-secondary"
                          :disabled="readonly"
                          @click="item.datelast = null"
                        >
                          <i class="fa fa-remove"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col cols="12" sm="6" md="4" xl="3">
                  <b-form-group
                    label="Date Start"
                    label-for="datestart"
                    label-cols="12"
                  >
                    <b-input-group>
                      <b-input-group-prepend>
                        <b-form-datepicker
                          size="sm"
                          v-model="item.datestart_df"
                          button-only
                          label-help=""
                          locale="en-GB"
                          hide-header
                          :disabled="readonly"
                        ></b-form-datepicker>
                      </b-input-group-prepend>
                      <b-form-input
                        size="sm"
                        id="date"
                        v-model="item.datestart_df"
                        type="text"
                        placeholder="YYYY-MM-DD"
                        autocomplete="off"
                        :disabled="readonly"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button
                          size="sm"
                          variant="outline-secondary"
                          :disabled="readonly"
                          @click="item.datestart_df = null"
                        >
                          <i class="fa fa-remove"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col cols="12" sm="6" md="4" xl="3">
                  <b-form-group
                    label="Date End"
                    label-for="dateend"
                    label-cols="12"
                  >
                    <b-input-group>
                      <b-input-group-prepend>
                        <b-form-datepicker
                          size="sm"
                          v-model="item.dateend_df"
                          button-only
                          label-help=""
                          locale="en-GB"
                          hide-header
                          :disabled="readonly"
                        ></b-form-datepicker>
                      </b-input-group-prepend>
                      <b-form-input
                        size="sm"
                        id="date"
                        v-model="item.dateend_df"
                        type="text"
                        placeholder="YYYY-MM-DD"
                        autocomplete="off"
                        :disabled="readonly"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button
                          size="sm"
                          variant="outline-secondary"
                          :disabled="readonly"
                          @click="item.dateend_df = null"
                        >
                          <i class="fa fa-remove"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col cols="12" sm="6" lg="4" xl="3">
                  <b-form-group label="At" label-for="at" label-cols="12">
                    <b-input-group>
                      <b-input-group-prepend>
                        <b-form-timepicker
                          size="sm"
                          v-model="item.at"
                          button-only
                          label-help=""
                          hide-header
                          :disabled="readonly"
                        ></b-form-timepicker>
                      </b-input-group-prepend>
                      <b-form-input
                        size="sm"
                        id="date"
                        v-model="item.at"
                        type="text"
                        placeholder="HH:MM"
                        autocomplete="off"
                        :disabled="readonly"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button
                          size="sm"
                          variant="outline-secondary"
                          :disabled="readonly"
                          @click="item.at = null"
                        >
                          <i class="fa fa-remove"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="6" md="4" xl="3">
                  <b-form-group
                    label="Repeat"
                    label-for="repeat"
                    label-cols="12"
                  >
                    <b-input-group>
                      <b-form-input
                        type="text"
                        v-model="item.repeat"
                        placeholder="Enter repeat"
                        size="sm"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button
                          size="sm"
                          variant="outline-secondary"
                          @click="item.repeat = ''"
                        >
                          <i class="fa fa-remove"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col cols="12" sm="6" md="4" lg="4" xl="3">
                  <b-form-group label="Days" label-for="days" label-cols="12">
                    <b-input-group>
                      <b-form-checkbox-group
                        v-model="item.days"
                        :options="[
                          { text: 'Mo', value: 1 },
                          { text: 'Tu', value: 2 },
                          { text: 'We', value: 3 },
                          { text: 'Th', value: 4 },
                          { text: 'Fr', value: 5 },
                          { text: 'Sa', value: 6 },
                          { text: 'Su', value: 0 },
                        ]"
                        buttons
                        button-variant="outline-success"
                        size="sm"
                        name="radio-btn-outline"
                        class="dayssmall"
                      ></b-form-checkbox-group>
                      <b-input-group-append>
                        <b-button
                          size="sm"
                          variant="outline-secondary"
                          @click="item.days = []"
                        >
                          <i class="fa fa-remove"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="6" md="4" xl="3">
                  <b-form-group
                    label="Priority"
                    label-for="priority"
                    label-cols="12"
                  >
                    <b-input-group>
                      <b-form-input
                        type="text"
                        v-model="item.priority"
                        placeholder="Enter priority"
                        size="sm"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button
                          size="sm"
                          variant="outline-secondary"
                          @click="item.priority = ''"
                        >
                          <i class="fa fa-remove"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col cols="12" sm="6" md="4" xl="3">
                  <b-form-group
                    label="Category"
                    label-for="category"
                    label-cols="12"
                  >
                    <b-input-group>
                      <b-form-input
                        type="text"
                        v-model="item.category"
                        placeholder="Enter category"
                        size="sm"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button
                          size="sm"
                          variant="outline-secondary"
                          @click="item.category = ''"
                        >
                          <i class="fa fa-remove"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="6" md="4" xl="3">
                  <b-form-group label="State" label-for="state" label-cols="12">
                    <b-form-radio-group
                      id="state"
                      v-model="item.running"
                      :options="[
                        { text: 'Running', value: '1' },
                        { text: 'Idle', value: '0' },
                      ]"
                      buttons
                      button-variant="outline-success"
                      size="sm"
                      name="radio-btn-outline"
                    ></b-form-radio-group>
                  </b-form-group>
                </b-col>
                <b-col cols="12" sm="6" md="4" xl="3">
                  <b-form-group label="Mode" label-for="runnow" label-cols="12">
                    <b-form-radio-group
                      id="runnow"
                      v-model="item.runnow"
                      :options="[
                        { text: 'Run Now', value: '1' },
                        { text: 'On Schedule', value: '0' },
                      ]"
                      buttons
                      button-variant="outline-success"
                      size="sm"
                      name="radio-btn-outline"
                    ></b-form-radio-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <b-form-group label="Config" label-for="data" label-cols="12">
                    <b-form-textarea
                      id="data"
                      v-model="item.data"
                      placeholder="Data"
                      rows="2"
                      class="smalltextarea"
                      :disabled="readonly"
                    ></b-form-textarea>
                  </b-form-group> </b-col
              ></b-row>
            </p>
          </b-tab>

          <b-tab>
            <template #title>
              <i class="fa fa-history text-primary mr-1"></i>Audit
            </template>
            <div class="py-3 px-0">
              <b-row>
                <b-col cols="12" sm="6" md="4" xl="3">
                  <b-form-group label-cols="12" label="From" label-size="sm">
                    <b-input-group>
                      <b-form-datepicker
                        size="sm"
                        v-model="datefrom"
                        label-help
                        hide-header
                        locale="en-GB"
                        placeholder="From"
                        :debounce="options.debounce"
                        :date-format-options="{
                          year: 'numeric',
                          month: 'numeric',
                          day: 'numeric',
                        }"
                      ></b-form-datepicker>

                      <b-input-group-append>
                        <b-button
                          size="sm"
                          squared
                          variant="outline-secondary"
                          :disabled="!datefrom"
                          @click="datefrom = ''"
                        >
                          <i class="fa fa-remove"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col cols="12" sm="6" md="4" xl="3">
                  <b-form-group label-cols="12" label="To" label-size="sm">
                    <b-input-group>
                      <b-form-datepicker
                        size="sm"
                        v-model="dateto"
                        label-help
                        hide-header
                        locale="en-GB"
                        placeholder="To"
                        :debounce="options.debounce"
                        :date-format-options="{
                          year: 'numeric',
                          month: 'numeric',
                          day: 'numeric',
                        }"
                      ></b-form-datepicker>

                      <b-input-group-append>
                        <b-button
                          size="sm"
                          squared
                          variant="outline-secondary"
                          :disabled="!dateto"
                          @click="dateto = ''"
                        >
                          <i class="fa fa-remove"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <div>
                <b-overlay
                  :show="options.overlay_show"
                  opacity=".9"
                  v-click-outside="outside"
                >
                  <div class="availtable datatable nested">
                    <b-table
                      :dark="$store.state.darkMode"
                      ref="btable"
                      sticky-header="350px"
                      striped
                      hover
                      small
                      caption-bottom
                      show-empty
                      :busy="busy"
                      :items="items"
                      :fields="options.fields"
                      :filter="find"
                      @row-clicked="rowClicked"
                    >
                      <template v-slot:table-busy>
                        <div class="text-center my-2">
                          <b-spinner
                            variant="primary"
                            class="align-middle mr-2"
                          ></b-spinner>
                          <strong class="text-primary">Loading...</strong>
                        </div>
                      </template>
                      <template v-slot:cell(icon)>
                        <i :class="options.icon" class="text-primary"></i>
                      </template>
                      <template v-slot:cell()="row">
                        <div
                          v-if="
                            options.badges &&
                            options.badges.find(
                              (obj) => obj.key == row.field.key
                            )
                          "
                        >
                          <span
                            v-html="
                              $helpers.badgeField(
                                row.item,
                                options.badges.find(
                                  (obj) => obj.key == row.field.key
                                ),
                                options
                              )
                            "
                          ></span>
                        </div>
                        <div v-else>{{ row.value }}</div>
                      </template>
                      <template
                        v-if="options.actions"
                        v-slot:cell(actions)="row"
                      >
                        <div
                          id="actions-container"
                          v-if="options.actions_as_elipses"
                        >
                          <b-button
                            variant="link"
                            size="sm"
                            title="Actions"
                            :id="'popover-target-' + row.item.id"
                            @click="$root.$emit('bv::hide::popover')"
                          >
                            <i class="fa fa-ellipsis-h text-primary"></i>
                          </b-button>
                          <b-popover
                            container="actions-container"
                            triggers="click blur"
                            placement="leftbottom"
                            :target="'popover-target-' + row.item.id"
                          >
                            <div>
                              <b-nav vertical>
                                <b-nav-item
                                  :title="action.label"
                                  v-for="action in $helpers.actionsValid(
                                    row.item,
                                    options
                                  )"
                                  :key="action.key"
                                  @click.stop="table_action(action.key, row)"
                                >
                                  <b-row class="px-2">
                                    <b-col class="px-0">
                                      <span class="text-normal">{{
                                        action.label
                                      }}</span>
                                    </b-col>
                                    <b-col cols="1">
                                      <i
                                        :class="action.icon"
                                        class="text-primary"
                                      ></i>
                                    </b-col>
                                  </b-row>
                                </b-nav-item>
                              </b-nav>
                            </div>
                          </b-popover>
                        </div>
                        <div v-else>
                          <b-button
                            variant="link"
                            size="sm"
                            v-for="action in $helpers.actionsValid(
                              row.item,
                              options
                            )"
                            :key="action.key"
                            @click.stop="table_action(action.key, row)"
                            :title="action.label"
                          >
                            <i :class="action.icon" class="text-primary"></i>
                          </b-button>
                        </div>
                      </template>

                      <template v-slot:row-details="row">
                        <b-card>
                          <component
                            :is="options.component.name"
                            :search="search"
                            @discard="discard(row)"
                          ></component>
                        </b-card>
                      </template>
                    </b-table>
                  </div>

                  <template #overlay>
                    <div class="text-center">
                      <p id="cancel-label">{{ options.overlay.message }}</p>
                      <hr />
                      <b-row>
                        <b-col>
                          <b-button
                            v-for="(button, index) in options.overlay.buttons"
                            :key="index"
                            :style="button.style ? button.style : 'width: 80px'"
                            :class="
                              button.class
                                ? button.class
                                : button.dispatch
                                ? null
                                : 'ml-2'
                            "
                            :variant="
                              button.variant
                                ? button.variant
                                : button.dispatch
                                ? 'outline-primary'
                                : 'outline-secondary'
                            "
                            :size="button.size ? button.size : 'sm'"
                            :squared="button.squared ? button.squared : true"
                            @click="
                              button.dispatch
                                ? dispatcher(button.dispatch)
                                : (options.overlay_show = false)
                            "
                            >{{ button.label }}</b-button
                          >
                        </b-col>
                      </b-row>
                    </div>
                  </template>
                </b-overlay>
                <b-row class="excelsheetbuttons px-1 mb-3">
                  <b-col>
                    <div v-if="busy">
                      <i class="fa fa-spinner fa-spin"></i>
                      <span class="ml-1">Updating ...</span>
                    </div>
                    <span v-if="!busy">Found {{ items.length }} rows</span>
                  </b-col>

                  <b-col class="text-right">
                    <b-link
                      id="pnr-excel"
                      class="mt-1 excel"
                      @click="$helpers.outputExcel({ items })"
                      title="Send to excel"
                    >
                      <i class="fa fa-file-excel-o" aria-hidden="true"></i>
                    </b-link>
                    <b-tooltip target="pnr-excel" triggers="hover"
                      >Grid to excel</b-tooltip
                    >
                  </b-col>
                </b-row>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </b-card-body>
      <b-card-footer class="mt-2 ml-1">
        <b-row>
          <b-col class="text-left">
            <div v-if="busy">
              <i class="fa fa-spinner fa-spin text-primary"></i>
            </div>
            <div v-else>
              <span v-html="message"></span>
            </div>
          </b-col>
          <b-col class="text-right" cols="8">
            <b-button
              squared
              size="sm"
              variant="secondary"
              class="mr-1"
              @click="discard"
            >
              <i class="fa fa-chevron-left pr-1"></i>
              Back
            </b-button>
            <b-button squared size="sm" variant="primary" @click="saveit">
              <i class="fa fa-check"></i>
              Save It
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </b-overlay>
</template>

<script>
import gql from "graphql-tag";

export default {
  name: "TaskSchedulerEdit",
  watch: {
    async datefrom() {
      await this.load();
    },
    async dateto() {
      await this.load();
    },
  },
  data() {
    return {
      toolbar_variant: "outline-primary",
      busy: false,
      readonly: false,
      items: [],
      item: { name: null },
      datefrom: this.$moment().format("YYYY-MM-DD"),
      dateto: this.$moment().format("YYYY-MM-DD"),
      options: {
        title: "Task Scheduler",
        icon: "fa fa-clock-o",
        fields: [
          {
            key: "icon",
            label: "",
            class: "text-right",
          },
          // {
          //   key: "name",
          //   label: "Name",
          //   sortable: true,
          //   sortDirection: "desc",
          //   type: "text",
          // },

          {
            key: "updated_at",
            label: "Updated At",
            class: "d-none d-sm-table-cell w-110px",
            sortable: true,
            formatter: (value, key, item) => {
              let result = "Never";
              if (value) {
                result = this.$moment
                  .unix(value / 1000)
                  .format("DD/MM/YYYY HH:mm:ss");
              }
              return result;
            },
          },

          {
            key: "data",
            label: "Data",
            sortable: true,
            sortDirection: "desc",
            type: "text",
            class: "text-left",
          },

          //   {
          //     key: "actions",
          //     label: "Actions",
          //     class: "actions w-120px",
          //   },
        ],
      },
    };
  },
  methods: {
    async load() {
      let variables = {
        id: this.idselected,
        dateformat: "YYYY-MM-DD HH:MM:ss",
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query tasksAt_mssql($id: String, $dateformat: String) {
              tasksAt_mssql(id: $id, dateformat: $dateformat) {
                id
                name
                enabled
                api
                datelast_df
                datestart_df
                dateend_df
                days
                at
                repeat
                priority
                data
                category
                isemail
                email
                isupload
                upload
                runnow
                running
                history {
                  updated_at
                  data
                }
              }
            }
          `,
          variables,
        });

        if (response.data.tasksAt_mssql.length > 0) {
          this.item = response.data.tasksAt_mssql[0];
          this.item.days = JSON.parse(this.item.days);
          this.items = this.item.history;
        }
      } catch (error) {
        console.log(error);
      }
      this.busy = false;
    },
    async saveit() {
      this.busy = true;

      let variables = {
        rows: [this.cleanit(this.item)],
        dateformat: "DD/MM/YY HH:MM",
      };
      console.log("variables", variables);

      delete variables.rows[0].days;
      delete variables.rows[0].history;
      delete variables.rows[0].datelast;

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation tasksAt_save_mssql(
              $rows: [TasksAt_input]
              $dateformat: String
            ) {
              tasksAt_save_mssql(rows: $rows, dateformat: $dateformat) {
                id
                name
                enabled
                api
                datelast
                datestart
                dateend
                days
                at
                repeat
                priority
                data
                category
                isemail
                email
                isupload
                upload
                runnow
                running
              }
            }
          `,
          variables,
        });
        console.log(response);
        this.message = "<span class='text-primary'>Saved it.</span>";
      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }

      this.busy = false;
    },
  },
};
</script>

<style>
</style>